module.exports = __webpack_public_path__ + "img/Ompelimo003.010bd922.jpg";